import React, { useEffect, useRef, useState } from "react";
import { shallowEqual } from "react-redux";
import UscVehicleInformation from "./common/UscVehicleInformation";
import { useUscSelector } from "../../../../redux/store";
import BasketReclaimableVatDisclaimer from "./content/BasketReclaimableVatDisclaimer";
import { UscNavStepEnum } from "../../../../utils/constants";
import { UscLabel } from "../../../../utils/labels";
import * as Styles from "./UscBasket.styles";
import Icon from "../../../../../shared-components/toyota/styles/atoms/Icon";
import { UscTrackingLocation } from "../../../../utils/tracking";
import UscBasketDetails from "./UscBasketDetails";
import { isRetailer } from "../../../../../../common-deprecated/utils";
import { useCommonSelector } from "../../../../../../common-deprecated/redux/commonStore";
import { useComponentRegistry } from "../../componentRegistry";
import UscVehicleInformationHeader from "./common/UscVehicleInformationHeader";
import { shouldShowPriceBreakdownSelector } from "../../../../utils/basketUtils";

// !! Note that this component has a "Loading" version as well: UscLoadingBasket.
const UscBasket = (): JSX.Element | null => {
    const commonSettings = useCommonSelector((state) => state.commonSettings);
    const enablePreviousNextCars = useUscSelector((state) => state.uscSettings.enablePreviousNextCars);
    const step = useUscSelector((state) => state.nav.step);
    const result = useUscSelector((state) => state.vehicle.result);
    const shouldShowPriceBreakdown = useUscSelector(shouldShowPriceBreakdownSelector, shallowEqual);

    const UscBasketCtas = useComponentRegistry("UscBasketCtas");
    const UscQrCode = useComponentRegistry("UscQrCode");

    const basketBottomRef = useRef<HTMLDivElement>(null);
    const basketStickTopRef = useRef<HTMLDivElement>(null);
    const [heightBottom, setHeightBottom] = useState<number>(0);
    const [basketStickyTopHeight, setBasketStickyTopHeight] = useState<number>(0);

    useEffect(() => {
        if (basketStickTopRef.current) {
            setBasketStickyTopHeight(basketStickTopRef.current.getBoundingClientRect().height);
        }
    }, [basketStickTopRef]);

    useEffect(() => {
        if (basketBottomRef.current) {
            setHeightBottom(basketBottomRef.current.getBoundingClientRect().height);
        }
    }, [basketBottomRef]);

    if (!result) return null;

    return (
        <Styles.Wrapper
            style={{
                "--basket-bottom-height": `${heightBottom}px`,
                "--basket-sticky-top-height": `${basketStickyTopHeight}px`,
            }}
        >
            <Styles.Top>
                <Styles.VehicleInformationDesktopWrapper ref={basketStickTopRef}>
                    <UscVehicleInformationHeader trackingLocation={UscTrackingLocation.Basket} />
                </Styles.VehicleInformationDesktopWrapper>
                <Styles.Scrollable>
                    <div>
                        <Styles.VehicleInformationDesktopWrapper>
                            <UscVehicleInformation trackingLocation={UscTrackingLocation.Basket} />
                        </Styles.VehicleInformationDesktopWrapper>

                        <UscBasketDetails showPriceBreakdown={shouldShowPriceBreakdown} />

                        {isRetailer(commonSettings) && (
                            <Styles.QrCodewrapper>
                                <UscQrCode />
                            </Styles.QrCodewrapper>
                        )}
                    </div>
                </Styles.Scrollable>
            </Styles.Top>
            <Styles.Bottom ref={basketBottomRef}>
                <UscBasketCtas trackingLocation={UscTrackingLocation.Basket} />
                <BasketReclaimableVatDisclaimer />

                {step === UscNavStepEnum.Pdp && (
                    <>
                        {/* TODO: Implement Previous/Next Ctas - UC-43 */}
                        {enablePreviousNextCars && (
                            <Styles.ButtonWrapper>
                                <Styles.Button type="button">
                                    <Icon variant="chevron-left" />
                                    <UscLabel label="uscBasketPreviousCarCta" />
                                </Styles.Button>
                                <Styles.Button type="button" iconRight>
                                    <Icon variant="chevron-right" />
                                    <UscLabel label="uscBasketNextCarCta" />
                                </Styles.Button>
                            </Styles.ButtonWrapper>
                        )}
                    </>
                )}
            </Styles.Bottom>
        </Styles.Wrapper>
    );
};

export default UscBasket;
